import Vue from 'vue'
import Router from 'vue-router'
import { store } from './../store/store'
import VueAnalytics from 'vue-analytics'
// import { temAcesso } from './../bibliotecas/seguranca/authLib'

// Containers
import Full from '@/layout/containers/Full'

import ErroPadrao from './../modulos/erro/ErroPadrao'
import ErroNaoAutorizado from './../modulos/erro/NaoAutorizado'
import Login from './../modulos/login/Login'
import AtualizarSenha from './../modulos/login/AtualizarSenha'

// Inclusão de rotas
import adminRotas from './../modulos/admin/AdminRotas'
import credoresRotas from './../modulos/credores/CredoresRotas'
import funcionariosRotas from './../modulos/funcionarios/FuncionariosRotas'
import paineisRotas from './../modulos/paineis/PaineisRotas'
import consultasRotas from './../modulos/consultas/ConsultasRotas'

Vue.use(Router)

const routes = [
    {
        path: '/',
        // redirect: '/dashboard',
        name: 'Home',
        component: Full,
        beforeEnter: (to, from, next) => {
            if (store.getters.estaAutenticado) {
                next()
            } else {
                store.dispatch('tryAutoLogin')
                if (store.getters.estaAutenticado) {
                    next()
                } else {
                    next('/login')
                }
            }
        },
        children: [
            adminRotas,
            credoresRotas,
            funcionariosRotas,
            paineisRotas,
            consultasRotas
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/atualizarsenha',
        name: 'AtualizarSenha',
        component: AtualizarSenha
    },
    {
        path: '/erro',
        name: 'Erro',
        component: ErroPadrao
    },
    {
        path: '/naoautorizado',
        name: 'Erro_NaoAutorizado',
        component: ErroNaoAutorizado
    }
]

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: routes
})

Vue.use(VueAnalytics, {
    id: 'UA-138321262-1',
    router
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js